import { createSlice } from 'utils/@reduxjs/toolkit';
import { ShoppingCartState } from './types';
import { reducers } from './reducers';

export const initialState: ShoppingCartState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'shoppingCart',
  initialState,
  reducers,
});

export const { actions: shoppingCartActions } = slice;
export const { reducer: shoppingCartReducer } = slice;
